import React, { useEffect } from "react";
import styled from "styled-components";

interface SButtonColor {
  btnColor?: string;
  btnText?: string;
  disabled?: boolean;
  btnTextColor?: string;
}

interface LineBtnProps extends SButtonColor {
  btnText?: string;
  btnClickEvent?: () => void;
  disabled?: boolean;
  icon?: string;
  btnHeight?: number;
  sPadding?: string;
  customIcon?: JSX.Element;
  btnTextColor?: string;
  [key: string]: any;
}

interface SLineBtnContainer extends LineBtnProps {
  hasImage?: boolean;
  disabled?: boolean;
  btnHeight?: number;
  btnText?: string;
  btnTextColor?: string;
}

export default function LineBtn({
  btnText,
  btnClickEvent,
  disabled,
  icon,
  btnColor,
  btnHeight,
  sPadding,
  customIcon,
  btnTextColor,
  ...rest
}: LineBtnProps) {
  useEffect(() => {}, [btnColor, icon, btnText]);

  return (
    <LineBtnContainer
      hasImage={icon ? true : false}
      disabled={disabled}
      btnHeight={btnHeight}
      btnText={btnText}
      sPadding={sPadding}
      onClick={() => {
        if (btnClickEvent) {
          btnClickEvent();
        }
      }}
      btnColor={btnColor}
      {...rest}
    >
      {(icon || customIcon) &&
        (customIcon ?? (
          <LineBtnIcon
            className="material-icons-outlined"
            btnColor={btnColor}
            btnText={btnText}
            btnTextColor={btnTextColor}
          >
            {icon}
          </LineBtnIcon>
        ))}

      {/* {btnText && ( */}
      <LineBtnText
        btnColor={btnColor}
        disabled={disabled}
        btnTextColor={btnTextColor}
      >
        {btnText}
      </LineBtnText>
      {/* )} */}
    </LineBtnContainer>
  );
}

const LineBtnText = styled.span<SButtonColor>`
  font-size: 13px;
  font-weight: 500;
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
  word-break: keep-all;
  color: ${({ btnTextColor, theme, btnColor }) =>
    btnTextColor ??
    (btnColor === "mint"
      ? theme.buttonColor.blueNormal
      : btnColor === "red"
      ? theme.buttonColor.redNormal
      : theme.color.gray600)};
`;

export const LineBtnIcon = styled.span<SButtonColor>`
  font-size: 16px;
  margin-right: ${({ btnText }) => (btnText ? 4 : 0)}px;
  color: ${({ btnTextColor, btnColor, theme }) =>
    btnTextColor ??
    (btnColor === "mint"
      ? theme.buttonColor.blueNormal
      : btnColor === "red"
      ? theme.buttonColor.redNormal
      : theme.color.gray600)};
  display: flex;
  align-items: center;
`;

const LineBtnContainer = styled.button<SLineBtnContainer>`
  padding: ${({ hasImage, btnText, sPadding }) =>
    sPadding ?? (btnText ? "0 16px" : hasImage ? "0 16px 0 14px" : "0 6px")};
  height: ${({ btnHeight }) => btnHeight ?? 32}px;
  border-radius: 5px;
  border: solid 1px
    ${({ theme, btnColor }) =>
      btnColor === "mint"
        ? theme.buttonColor.blueNormal
        : btnColor === "red"
        ? theme.buttonColor.redNormal
        : theme.buttonColor.lineNormal};
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: ${({ theme, btnColor }) =>
      btnColor === "mint"
        ? theme.buttonColor.blueHover
        : btnColor === "red"
        ? theme.buttonColor.redHover
        : theme.buttonColor.lineHover};

    ${LineBtnText}, ${LineBtnIcon} {
      color: ${({ theme, btnColor }) =>
        btnColor === "mint"
          ? theme.buttonColor.blueHover
          : btnColor === "red"
          ? theme.buttonColor.redHover
          : theme.color.gray400};
    }
  }

  &:active {
    border-color: ${({ theme, btnColor }) =>
      btnColor === "mint"
        ? theme.buttonColor.bluePressed
        : btnColor === "red"
        ? theme.buttonColor.redPressed
        : theme.buttonColor.linePressed};

    ${LineBtnText}, ${LineBtnIcon} {
      color: ${({ theme, btnColor }) =>
        btnColor === "mint"
          ? theme.buttonColor.bluePressed
          : btnColor === "red"
          ? theme.buttonColor.redPressed
          : theme.buttonColor.linePressedText};
    }
  }

  &:disabled {
    cursor: not-allowed;
    border-color: ${({ theme, btnColor }) =>
      btnColor === "mint"
        ? theme.buttonColor.blueDisabled
        : btnColor === "red"
        ? theme.buttonColor.redDisabled
        : theme.buttonColor.lineDisabled};

    ${LineBtnText}, ${LineBtnIcon} {
      color: ${({ theme, btnColor }) =>
        btnColor === "mint"
          ? theme.buttonColor.blueDisabled
          : btnColor === "red"
          ? theme.buttonColor.redDisabled
          : theme.buttonColor.lineDisabled};
    }
  }
`;
